import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

interface NewVideoModalContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const NewVideoModalContext = createContext<NewVideoModalContextType | undefined>(undefined);

export function NewVideoModalProvider({ children }: { children: React.ReactNode }) {
  useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  // Block body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <NewVideoModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
    </NewVideoModalContext.Provider>
  );
}

export function useNewVideoModal() {
  useLanguage();
  const context = useContext(NewVideoModalContext);
  if (context === undefined) {
    throw new Error(translateInterfaceText("useNewVideoModal must be used within a NewVideoModalProvider"));
  }
  return context;
}
